import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { placesEnvironment } from '../places-environment';
import { placeDetailsSchema } from '../schemas/place-details.schema';

/**
 * Get an array of place details by placeIds
 * HARD LIMIT: 50
 * @param placeIds Array of trimblePlaceIds
 * @returns An array of place details
 */
export function postPlacesPlaceDetailsBulk(
  this: unknown,
  request: {
    getSites?: boolean;
    placeIds: string[];
  }
) {
  const params =
    typeof request.getSites === 'undefined'
      ? ''
      : `?${new URLSearchParams([['getSites', String(request.getSites)]]).toString()}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${placesEnvironment.resolve(this).placesPlaceDetailsBulkUrl}${params}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify(request.placeIds),
        }
      )
    )
  ).pipe(selectData(z.array(placeDetailsSchema)));
}
